var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreenTickUpdateCds = function SvgGreenTickUpdateCds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 275,
    height: 178,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3C3",
    d: "m93.177 132.974-.085-119.242 82.552-.059.085 119.242z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3C3",
    d: "m93.165 133.115-.084-119.242 82.551-.058.085 119.242zM.434 132.958.323 13.716l78.166-.042.11 119.242z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M101.507 40.562h65.809v7.92h-65.809zM106.978 54.595h54.869v7.92h-54.869z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M101.496 40.703h65.809v7.92h-65.809zM106.966 54.737h54.869v7.92h-54.869zM4.377 40.562h65.809v7.92H4.377zM9.848 54.595h54.869v7.92H9.848z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3C3",
    d: "m93.178 133.199-.085-119.242 82.552-.059.085 119.242z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M101.507 40.786h65.809v7.92h-65.809zM106.978 54.819h54.869v7.92h-54.869z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0EEC0",
    d: "m93.415 133.115-.084-119.242 82.551-.058.085 119.242z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3C3",
    d: "m192.383 132.974-.084-119.242 82.551-.058.085 119.242z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M200.714 40.562h65.809v7.92h-65.809zM206.185 54.595h54.869v7.92h-54.869z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133.982,
    cy: 65.388,
    r: 51.49,
    fill: "#169B62"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFE",
    fillRule: "evenodd",
    d: "m163.154 53.728-37.619 37.619-18.833-18.833 9.488-9.488 9.345 9.345 28.131-28.131z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#125A42",
    stroke: "#125A42",
    strokeWidth: 6,
    d: "M199.244 156.918a5.276 5.276 0 0 0 8.276-6.544l-37.168-47.002-8.276 6.544z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.983,
    cy: 65.055,
    r: 51.334,
    stroke: "#125A42",
    strokeWidth: 12,
    transform: "rotate(-6.395 133.983 65.055)"
  })));
};
export { SvgGreenTickUpdateCds as ReactComponent };
export default __webpack_public_path__ + "images/green-tick-update-cds.svg";